export default "__VITE_ASSET__BJ7nf6qR__"